import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";

export type AmenityIconImageProps = {
  src: string;
  alt?: string;
  size: number;
  borderRadius?: number;
  style?: React.CSSProperties;
};

export function AmenityIconImage(props: AmenityIconImageProps) {
  const { src, alt = "", size, borderRadius = 4, style } = props;
  const imgRef = useRef<HTMLImageElement>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const img = imgRef.current;
    if (img?.complete && img.naturalWidth > 0) {
      setIsLoading(false);
    }
  }, [src]);

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        borderRadius,
        overflow: "hidden",
        background: "#FAFAFA",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        ...style,
      }}
    >
      {isLoading && (
        <Spin
          indicator={<LoadingOutlined spin style={{ fontSize: size > 48 ? 20 : 14 }} />}
          style={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1,
          }}
        />
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.25s ease",
        }}
      />
    </div>
  );
}
